// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ranking_wrapper__lnDGZ","optionsList":"Ranking_optionsList__3zPgi","option":"Ranking_option__3EcQ7","leftSide":"Ranking_leftSide__2I0cj"};